// NIGHT-DIRECTSTAFF-2026-10-24 §1: the candidate's own availability (migrations/2026-10-24-candidate-availability.sql, filed for the hub).
// "Send availability link" makes a 7-day, single-use link (candidate_availability_link, staff only; the token comes back once) to the
// onboard portal's /v/<token> page, sent through the Send box. What they answer lands on the candidate: available_from,
// preferred_states / settings / shifts, looking_status (active | open | not_now), availability_updated_at. Dark until the hub applies it.
export const AVAIL_COLS = ['available_from', 'preferred_states', 'preferred_settings', 'preferred_shifts', 'looking_status', 'availability_updated_at'];
export const LOOKING_WORDS = { active: 'Actively looking', open: 'Open to the right offer', not_now: 'Not right now' };
export const AVAIL_LOG_TYPE = 'availability';
const ERRORS = {
  'availability:rate_limited': 'Five links were already made for them today. Use the newest one, or try tomorrow.',
  'availability:no_such_candidate': 'That candidate is no longer there. Refresh.',
};
const plain = (e) => { const m = /availability:[a-z_:]+/.exec(String((e && e.message) || '')); return (m && ERRORS[m[0]]) || (e && e.message) || 'The link could not be made.'; };

export const availabilityUrl = (token, base) => `${String(base || 'https://onboard.protherapystaffing.com').replace(/\/$/, '')}/v/${token}`;
export function availabilityMessage(name, link) {
  const f = String(name || '').trim().split(/\s+/)[0] || '';
  const hi = /^[A-Za-z][A-Za-z'.-]*$/.test(f) ? `Hi ${f},` : 'Hi,';
  return `${hi} could you tell us when and where you'd like to work next? It takes a minute: ${link} (works once, for 7 days). Thank you!`;
}
export const availNote = (linkId, channel, by) => `Availability link ${linkId} sent by ${channel === 'copy' ? 'copied link' : channel}${by ? ` by ${by}` : ''}`;
const day = (d) => new Date(`${String(d).slice(0, 10)}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
/** "Actively looking · from Nov 13, 2026 · CO, TX · Outpatient · Days" ; '' when they never answered */
export function availabilityLine(c) {
  if (!c || !c.looking_status) return '';
  const list = (a) => (Array.isArray(a) && a.length ? a.join(', ') : '');
  return [LOOKING_WORDS[c.looking_status] || c.looking_status, c.available_from ? `from ${day(c.available_from)}` : 'available now', list(c.preferred_states),
    list(c.preferred_settings), list(c.preferred_shifts)].filter(Boolean).join(' · ');
}

/** NIGHT-DIRECTSTAFF-2026-10-28 §7: the one line on the candidate card and the pipeline chip -- "Available from Nov 13 · CO, TX ·
 *  Outpatient" ("Available now · ..." with no date); "Not looking right now"; '' when they never answered */
export function availabilityShort(c) {
  if (!c || !c.looking_status) return '';
  if (c.looking_status === 'not_now') return 'Not looking right now';
  const short = (d) => new Date(`${String(d).slice(0, 10)}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
  const list = (a) => (Array.isArray(a) && a.length ? a.join(', ') : '');
  return [c.available_from ? `Available from ${short(c.available_from)}` : 'Available now', list(c.preferred_states), list(c.preferred_settings)].filter(Boolean).join(' · ');
}

export function makeAvailabilityApi(supabase) {
  return {
    async probe() { try { const { error } = await supabase.from('candidates').select(AVAIL_COLS.join(','), { head: true }).limit(0); return !error; } catch { return false; } },
    async link(candidateId) {
      const { data, error } = await supabase.rpc('candidate_availability_link', { p_candidate_id: candidateId });
      if (error) throw new Error(plain(error));
      return data;
    },
    async logSent(candidateId, linkId, channel, by) {
      const { error } = await supabase.from('activity_log').insert({ candidate_id: candidateId, date: new Date().toISOString().slice(0, 10), type: AVAIL_LOG_TYPE, note: availNote(linkId, channel, by) });
      if (error) throw new Error(`Sent, but not logged on the timeline: ${error.message}`);
    },
  };
}
